// eslint-disable-next-line import-x/no-unresolved
import { useRegisterSW } from 'virtual:pwa-register/react';

function RegisterSW() {
  const { updateServiceWorker } = useRegisterSW({
    onNeedRefresh() {
      try {
        console.log('Update - Service Worker');
        updateServiceWorker(true);
      } catch (e) {
        console.log(e);
      }
    },
  });

  return <></>;
}

export default RegisterSW;
